import { render, staticRenderFns } from "./FormInputBasic.vue?vue&type=template&id=3cc16d2c&"
import script from "./FormInputBasic.vue?vue&type=script&lang=js&"
export * from "./FormInputBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports